module.exports = __webpack_public_path__ + "img/schellen.9318cff9.png";